/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Image lightbox contrast
 */
export enum LIGHTBOX_CONTRAST {
  /**
   * Light (default).
   */
  LIGHT = 'light',

  /**
   * Dark.
   */
  DARK = 'dark',
}
